import { jsx as _jsx } from "react/jsx-runtime";
import { PregnancyWellBeingStatus } from "@madmedical/medical";
import BlandMood from "../../pics/Pregnancy/moods/BlandMood";
import ChangingMood from "../../pics/Pregnancy/moods/ChangingMood";
import CalmMood from "../../pics/Pregnancy/moods/CalmMood";
import HappyMood from "../../pics/Pregnancy/moods/HappyMood";
import BadMood from "../../pics/Pregnancy/moods/BadMood";
const PregnantMoodPics = ({ status }) => {
    switch (status) {
        case PregnancyWellBeingStatus.BadTemper:
            return _jsx(BadMood, {});
        case PregnancyWellBeingStatus.Moody:
            return _jsx(BlandMood, {});
        case PregnancyWellBeingStatus.Fluctuating:
            return _jsx(ChangingMood, {});
        case PregnancyWellBeingStatus.Calm:
            return _jsx(CalmMood, {});
        case PregnancyWellBeingStatus.Cheerful:
            return _jsx(HappyMood, {});
    }
};
export default PregnantMoodPics;
